import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  inject,
  ChangeDetectorRef,
} from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { PostTradeService } from '../../post-trade.service';
import { CaseManagementService } from '../../../case-management/case-management.service';
import { SessionStorageService } from '../../../services/session-storage.service';
import { Router } from '@angular/router';
import Highcharts from 'highcharts';
import {
  repInfoKey,
  keyMetricsKey,
  caseHistoryKey,
  repReviewKey,
  tradeHistoryKey,
  allClientAccountsKey,
  repHistoryKey,
} from './rep-review-detail-keys';
import { chartOptions } from '../../trade-review/trade-review-detail/trade-review-detail-keys';
import { scoreClassKey } from '../../../lib/shared-value-keys';
import { MatSnackBar } from '@angular/material/snack-bar';
import isEmpty from 'lodash-es/isEmpty';
import { MatDialog } from '@angular/material/dialog';
// import { Chart } from 'angular-highcharts';
import { CaseCreationDialogComponent } from '../../components/case-creation-dialog/case-creation-dialog.component';
import { TagsEvaluationService } from '../../../services/tags-evaluation.service';
import { RepDetail } from '../../../models/post-trade-models';

@Component({
  selector: 'app-rep-review-detail',
  templateUrl: './rep-review-detail.component.html',
  styleUrls: ['./rep-review-detail.component.scss'],
  standalone: false,
})
export class RepReviewDetailComponent implements OnInit, OnDestroy {
  private dialog = inject(MatDialog);
  private changeDetector = inject(ChangeDetectorRef);
  fb = inject(FormBuilder);
  ptSvc = inject(PostTradeService);
  cms = inject(CaseManagementService);
  ss = inject(SessionStorageService);
  private route = inject(Router);
  private location = inject(Location);
  private snacky = inject(MatSnackBar);
  private tes = inject(TagsEvaluationService);

  @Input() repId;
  rights = [];
  repDetail;
  repInfoKey = repInfoKey;
  keyMetricsKey = keyMetricsKey;
  scoreClassKey = scoreClassKey;
  caseHistoryKey = caseHistoryKey;
  repReviewKey = repReviewKey;
  repHistoryKey = repHistoryKey;
  tradeHistoryKey = tradeHistoryKey;
  allClientAccountsKey = allClientAccountsKey;
  isEmpty = isEmpty;
  relatedAccountRows = 5;
  recentActivityRows = 5;
  caseHistory = [];
  caseHistoryRows = 5;
  reviewCase = false;
  caseChangesMade = false;
  caseData;
  aiSummary = [];
  selectedActionTab = 0;
  chartSelection = 'PT';
  chartOptions = chartOptions;
  updateFlag = false;

  unsubscribe: Subject<any> = new Subject();
  loading = false;

  ngOnInit(): void {
    this.loading = true;
    this.rights = this.ss.get('rights');
    this.ptSvc.getRepDetail(this.repId).subscribe((resp: RepDetail) => {
      if (resp.Details?.bridges) {
        resp.Details.bridges.forEach(bridge => {
          if (bridge.trueRules) {
            bridge.trueRules.forEach(rule => {
              rule.explanation =
                rule.reasonType === 'Negative'
                  ? this.tes.evalTags(rule.explanation)
                  : '';
              rule.headline =
                rule.reasonType === 'Negative'
                  ? this.tes.evalTags(rule.headline)
                  : '';
              bridge.negativeReason =
                rule.reasonType === 'Negative' ? true : bridge.negativeReason;
            });
          }
        });
      }

      this.repDetail = resp;

      if (resp['Details']['Chart_AllClient_PT']) {
        this.chartOptions.series.push({
          data: resp['Details']['Chart_AllClient_PT'],
          name: 'Amount',
          type: 'pie',
        });

        this.updateFlag = true;
      }

      this.loading = false;
    });

    this.cms
      .getRelatedCases(this.repId, ['Rep', 'RepGroup'])
      .subscribe(resp => {
        if (resp['length'] > 0) {
          Object.keys(resp).map(index => {
            this.caseHistory.push(resp[index]);
          });
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  returnZero() {
    return 0;
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  toggleReviewed(reviewStatus) {
    this.loading = true;

    this.ptSvc
      .updateRep({
        repID: [this.repId],
        ApprovalStatus: reviewStatus,
      })
      .subscribe(() => {
        this.ptSvc.getRepDetail(this.repId).subscribe((resp: RepDetail) => {
          this.snacky.open(`${this.repId} was updated!`, 'Close', {
            duration: 4000,
          });

          this.repDetail = resp;
          this.loading = false;
        });
      });
    setTimeout(() => {
      this.loading = false;
    }, 4000);
  }

  initiateCase() {
    const alerts = [];

    if (
      this.repDetail?.Details?.bridges &&
      this.repDetail?.Details?.bridges.length > 0
    ) {
      this.repDetail.Details.bridges[0].trueRules.map(alert => {
        if (alert.score < 0) {
          alerts.push(alert);
        }
      });
    }

    const confirmationDialog = this.dialog.open(CaseCreationDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        alerts: alerts,
      },
    });

    confirmationDialog.afterClosed().subscribe(resp => {
      if (resp?.action === 'continue') {
        this.loading = true;
        const caseData = {
          CaseManagement: {
            Type: 'Rep',
            Title: this.repId,
          },
          CaseToProfile: {
            ProfileID: [this.repId],
          },
          Client_Rep: {
            RepCode: [this.repDetail.RepID],
          },
        };

        if (resp?.caseAlerts.length > 0) {
          caseData['PostTradeAlerts'] = { AlertIds: resp.caseAlerts };
        }

        if (resp?.assignedTo) {
          caseData['CaseManagement']['AssignedTo'] = resp?.assignedTo;
        }

        if (resp?.repName) {
          caseData['CaseManagement']['AssignedToName'] = resp?.repName;
        }

        this.cms
          .createCaseManagementRecord(this.repId, caseData)
          .subscribe(resp => {
            this.loading = false;
            const note = {
              CaseRecordId: resp['result'],
              NoteText: `A case has been initiated for the selected rep.
          Please provide any necessary notes or actions.<br/><br/>
          ~${this.repId}`,
              NoteTypeId: 3,
            };

            this.cms.addCaseRecordNote(note).subscribe({
              next: () => {
                this.snacky.open('Case created & note saved', 'Close', {
                  duration: 2000,
                });
              },
              error: error => {
                this.snacky.open(`Error: ${error}`);
              },
            });

            this.nav(`case-management/case-manager/${resp['result']}`);
          });
      }
    });
  }

  toggleCaseReview(caseItem) {
    this.cms.getCaseManagementProfile(caseItem.CRID).subscribe(() => {
      // Leaving this here in case we want to embed the case manager later/maybe for another configuration?
      // this.caseData = caseItem;
      // this.reviewCase = !this.reviewCase;
      window.open(
        `${this.location.prepareExternalUrl('/case-management/case-manager/')}${
          caseItem.CRID
        }`,
        '_blank'
      );
    });
  }

  toggleRows(rowProp, value) {
    if (this[rowProp] !== value) {
      this[rowProp] = value;
    } else {
      this[rowProp] = 5;
    }
  }

  changeCaseValue(value) {
    this.caseChangesMade = value;
  }

  changeChartSelection(ev) {
    this.chartSelection = ev.value;
    this.getChartData();
  }

  getChartData() {
    this.updateFlag = false;
    this.chartOptions.series = [];
    this.chartOptions.series[0] = {
      data: this.repDetail.Details[`Chart_AllClient_${this.chartSelection}`],
      type: 'pie',
    };
    this.changeDetector.detectChanges();
    this.updateFlag = true;
  }

  showChart() {
    let datapointCheck = '';

    if (
      this.repDetail.Details[`Chart_AllClient_${this.chartSelection}`].length <
      1
    ) {
      datapointCheck = 'hide';
    } else if (
      this.repDetail.Details[`Chart_AllClient_${this.chartSelection}`]
        .length === 1
    ) {
      this.repDetail.Details[`Chart_AllClient_${this.chartSelection}`].map(
        chartpoint => {
          if (chartpoint.y === 0 && chartpoint.name === '') {
            datapointCheck = 'hide';
          }
        }
      );
    } else {
      let emptyDataCount = 0;
      this.repDetail.Details[`Chart_AllClient_${this.chartSelection}`].map(
        chartpoint => {
          if (chartpoint.y === 0 && chartpoint.name === '') {
            emptyDataCount = emptyDataCount + 1;
          }
        }
      );

      if (
        emptyDataCount >=
        this.repDetail.Details[`Chart_AllClient_${this.chartSelection}`].length
      ) {
        datapointCheck = 'hide';
      }
    }

    return datapointCheck;
  }
}
